import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';
import { CookieEnum } from '../../enums/cookie-enum';
import { config } from '../../config/config';

const createBaseQuery = (baseUrl: string) => {
  return fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = Cookies.get(CookieEnum.ACCESS_TOKEN);
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  });
};

export const baseQueryWithInterceptor = (baseUrl: string) => {
  const baseQuery = createBaseQuery(baseUrl);

  return async (args: any, api: any, extraOptions: any) => {
    let response = await baseQuery(args, api, extraOptions);

    if ((response as any)?.error?.status === 401) {
      const refreshToken = Cookies.get(CookieEnum.REFRESH_TOKEN);

      const refreshTokenQuery = fetchBaseQuery({
        baseUrl: `${config.API_BASE_URL}/auth/refresh-token`,
        prepareHeaders: (headers) => {
          if (refreshToken) {
            headers.set('Authorization', `Bearer ${refreshToken}`);
          }
          return headers;
        },
      });

      const refreshResponse = await refreshTokenQuery(
        { url: '', method: 'POST' },
        api,
        extraOptions
      );

      if (refreshResponse?.data) {
        const data = refreshResponse.data as any;
        const newAccessToken = data.accessToken;
        const newRefreshToken = data.refreshToken;

        if (newAccessToken) {
          Cookies.set(CookieEnum.ACCESS_TOKEN, newAccessToken);
        }

        if (newRefreshToken) {
          Cookies.set(CookieEnum.REFRESH_TOKEN, newRefreshToken);
        }

        response = await baseQuery(args, api, extraOptions);
      } else {
        Cookies.remove(CookieEnum.ACCESS_TOKEN);
        Cookies.remove(CookieEnum.REFRESH_TOKEN);
      }
    }

    return response;
  };
};
